import { render, staticRenderFns } from "./ProjectEffectiveness.vue?vue&type=template&id=5f89ec6b&scoped=true"
import script from "./ProjectEffectiveness.vue?vue&type=script&lang=js"
export * from "./ProjectEffectiveness.vue?vue&type=script&lang=js"
import style0 from "./ProjectEffectiveness.vue?vue&type=style&index=0&id=5f89ec6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f89ec6b",
  null
  
)

export default component.exports